import { render } from "./bookDetails.vue?vue&type=template&id=08a9a31a&scoped=true"
import script from "./bookDetails.vue?vue&type=script&lang=js"
export * from "./bookDetails.vue?vue&type=script&lang=js"

import "./bookDetails.vue?vue&type=style&index=0&id=08a9a31a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a9a31a"]])

export default __exports__